import TrainerDetails from "./TrainerDetails";
export default TrainerDetails;
